import { useNavigator } from '@repo/toolkit/use-navigator'
import { SettingIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'

import { createCanGoOutAloneCondition } from '../../../api/can-go-out-alone-conditions/create-can-go-out-alone-condition'
import UserNavBar from '../../../components/elements/nav-bar'
import { CanGoOutAloneConditionForm } from '../../../components/pages/can-go-out-alone-condition/can-go-out-alone-condition-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
export function CanGoOutAloneConditionsCreatePage() {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createCanGoOutAloneCondition,
    onError: showAxiosError
  })

  return (
    <div>
      <UserNavBar title={'Créer une condition de sortie seul'} icon={SettingIcon} />
      <div className={'h-4'} />
      <CanGoOutAloneConditionForm
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            const res = await mutateAsync(values)
            navigate(
              Paths.CAN_GO_OUT_ALONE_CONDITION_UPDATE_PAGE.replace(':id', res.id.toString()),
              { replace: true }
            )
          },
          onCancel: () => back(Paths.CAN_GO_OUT_ALONE_CONDITION_LIST_PAGE)
        })}
      />
    </div>
  )
}
